export const gardenPlantTypes = ['31', '43', '44', '48', '51', '52', '53', '54', '55', '58', '59'];

export const defaultSeedQuality = "17";